import { atom } from 'jotai';

export const errorHandler = atom<boolean>(false);